/* ============================================================
   Manzzani 2026 — comportamiento
   Vanilla. Sin jQuery, sin dependencias.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Revelado al hacer scroll -------------------------------
     .mz-js solo lo agrega un script que de verdad corrió, así que
     un fallo de JS nunca puede dejar la página en blanco. */
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('mz-js');

    /* threshold va en 0 a proposito: lo observado es el CONTENEDOR, no cada
       ficha, y un threshold fraccionario se mide contra el area del contenedor.
       En celular la rejilla de Clasicas mide 8250px de alto, asi que un 0.12
       exigia 990px visibles dentro de un viewport de 812 (731 tras el
       rootMargin). Inalcanzable => no disparaba nunca => las fichas se
       quedaban en opacity:0 para siempre, visibles solo el instante anterior
       a que .mz-js entrara. Se rompia a partir de 12 productos: por eso
       Tamarindo (6) salia bien y Clasicas, Premium y Catalogo no.
       Con 0 basta que asome un pixel. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);          // una sola vez por elemento
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    document.querySelectorAll('[data-mz-reveal], [data-mz-stagger]')
      .forEach(function (el) { io.observe(el); });
  }

  /* --- Navegación móvil --------------------------------------- */
  var burger = document.querySelector('[data-mz-burger]');
  var nav = document.querySelector('[data-mz-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Cerrar con Escape y devolver el foco al disparador.
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  }

  /* --- Contador del carrito, anunciado ------------------------ */
  window.mzSetCartCount = function (n) {
    document.querySelectorAll('[data-mz-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('aria-label', n + (n === 1 ? ' artículo en el carrito' : ' artículos en el carrito'));
    });
  };

  /* --- Fecha de entrega: cedemos el paso a Buunto -------------
     Si la app monta su propio selector, escondemos el nativo para no
     pedir la fecha dos veces. Si no aparece en 2.5s, el nativo se queda:
     el pedido #3370 llego sin fecha, asi que no se puede depender de ella. */
  var fechaBox = document.querySelector('[data-mz-fecha]');
  if (fechaBox) {
    setTimeout(function () {
      var buunto = document.querySelector('[class*="buunto"], [id*="buunto"]');
      if (buunto) {
        fechaBox.hidden = true;
        var inp = fechaBox.querySelector('input');
        if (inp) inp.disabled = true;   // que no compita por el mismo atributo
      }
    }, 2500);
  }

})();

/* ============================================================
   Opciones de producto
   Radios nativos -> una variante. El <select> con las
   combinaciones concatenadas obligaba a leer seis renglones
   para tomar dos decisiones independientes.
   ============================================================ */
(function () {
  'use strict';

  function montar(form) {
    var datos = form.querySelector('[data-mz-variants]');
    var hidden = form.querySelector('[data-mz-variant]');
    if (!datos || !hidden) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var radios = Array.prototype.slice.call(form.querySelectorAll('.mz-opt__input'));
    if (!radios.length) return;

    var cutmap = null;
    var cutEl = document.querySelector('[data-mz-cutmap]');
    if (cutEl) { try { cutmap = JSON.parse(cutEl.textContent); } catch (e) {} }

    var precioEl = document.querySelector('[data-mz-price]');
    var mediaEl  = document.querySelector('.mz-pdp__media img');
    var submit   = form.querySelector('[data-mz-submit]');

    function elegidas() {
      var v = [null, null, null];
      radios.forEach(function (r) {
        if (r.checked) v[parseInt(r.dataset.pos, 10) - 1] = r.value;
      });
      return v;
    }

    function casa(variante, sel) {
      for (var i = 0; i < 3; i++) {
        if (sel[i] !== null && variante.o[i] !== sel[i]) return false;
      }
      return true;
    }

    function sincronizar(porUsuario) {
      var sel = elegidas();
      var exacta = null;
      for (var i = 0; i < variantes.length; i++) {
        if (casa(variantes[i], sel)) { exacta = variantes[i]; break; }
      }

      /* Agotadas: una opcion se marca contra lo YA elegido en los otros
         grupos, no en abstracto. "En Canasta" puede existir para
         Chocolate Blanco y no para Obscuro. */
      radios.forEach(function (r) {
        var pos = parseInt(r.dataset.pos, 10) - 1;
        var prueba = sel.slice();
        prueba[pos] = r.value;
        var hay = variantes.some(function (vr) { return casa(vr, prueba) && vr.a; });
        var chip = form.querySelector('label[for="' + r.id + '"]');
        if (chip) {
          chip.classList.toggle('is-out', !hay);
          var aviso = chip.querySelector('.mz-opt__out');
          if (aviso) aviso.hidden = hay;      /* texto, no solo color */
        }
        r.disabled = !hay && !r.checked;
      });

      if (!exacta) return;

      hidden.value = exacta.id;
      hidden.dataset.title = exacta.t || '';
      hidden.dataset.price = exacta.p || '';

      if (precioEl) precioEl.textContent = exacta.p;
      if (submit) submit.dataset.price = exacta.p;
      // La foto de Shopify solo entra si NO hay recorte. El recorte tiene
      // fondo transparente; la de Shopify trae un rectangulo blanco y al
      // pisarla la manzana quedaba metida en una caja.
      if (mediaEl) {
        var esRecorte = mediaEl.classList.contains('mz-foto--recorte');
        if (esRecorte && cutmap) {
          // Con recorte, se cambia al recorte del ingrediente elegido.
          var ing = sel[0];
          if (ing && cutmap[ing]) { mediaEl.removeAttribute('srcset'); mediaEl.src = cutmap[ing]; }
        } else if (!esRecorte && exacta.img) {
          mediaEl.removeAttribute('srcset'); mediaEl.src = exacta.img;
        }
      }

      /* La URL guarda la variante: compartir el enlace conserva la eleccion. */
      if (porUsuario && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', exacta.id);
        history.replaceState({}, '', u);
      }

      /* mz-sabores escucha aqui para recalcular N. */
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { sincronizar(true); });
    });
    sincronizar(false);
  }

  function init() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (f) montar(f);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());

/* ============================================================
   Textura al pasar el cursor
   Antes era un boton que cambiaba de vista. Ahora la textura se
   cruza encima de la foto mientras el raton esta encima y se va
   al salir: se compara sin perder de vista la manzana.

   En tactil no existe el hover, asi que ahi si hay un boton. Sin
   el, la textura seria inalcanzable justo en el telefono, que es
   donde compra la mayoria.
   ============================================================ */
(function () {
  'use strict';
  var caja = document.querySelector('[data-mz-tex]');
  if (!caja) return;

  var media = document.querySelector('.mz-pdp__media');
  var capa  = caja.querySelector('[data-mz-tex-img]');
  var bot   = caja.querySelector('[data-mz-tex-tactil]');
  if (!media || !capa) return;

  var tactil = window.matchMedia('(hover: none)').matches;
  var mapa = null, mapEl = caja.querySelector('[data-mz-texmap]');
  if (mapEl) { try { mapa = JSON.parse(mapEl.textContent); } catch (e) {} }

  function fuente() {
    if (!caja.dataset.texVariante) return caja.dataset.texSrc || '';
    var hidden = document.querySelector('[data-mz-variant]');
    var titulo = hidden ? (hidden.dataset.title || '') : '';
    if (!mapa) return '';
    // De la llave MAS LARGA a la mas corta: "Nuez" aparece dentro de
    // "Nuez de la India" y con indexOf a secas se comia a la segunda.
    var ks = Object.keys(mapa).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < ks.length; i++) {
      if (titulo.indexOf(ks[i]) > -1) return mapa[ks[i]];
    }
    return '';
  }

  var cargada = '';
  function precargar() {
    var s = fuente();
    if (s && s !== cargada) { capa.src = s; cargada = s; }
    return !!s;
  }

  function mostrar(on) {
    if (on && !precargar()) return;           // sin textura, no se hace nada
    media.classList.toggle('is-textura', on);
    if (bot) bot.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  if (tactil) {
    if (bot) bot.addEventListener('click', function () {
      mostrar(!media.classList.contains('is-textura'));
    });
  } else {
    media.addEventListener('mouseenter', function () { mostrar(true); });
    media.addEventListener('mouseleave', function () { mostrar(false); });
    // Con teclado tambien: al enfocar la ficha se revela igual.
    media.addEventListener('focusin', function () { mostrar(true); });
    media.addEventListener('focusout', function () { mostrar(false); });
  }

  // Si cambia la variante, la textura sigue a la nueva.
  var hidden = document.querySelector('[data-mz-variant]');
  if (hidden) hidden.addEventListener('change', function () {
    cargada = '';
    if (media.classList.contains('is-textura')) mostrar(true);
  });

  precargar();
}());
